import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Navigation, Autoplay, EffectCoverflow } from 'swiper/modules';
import SectionHeading from '../Common/SectionHeading';
import Image from 'next/image';

const LifeAtDi = ({ title, customClass, data=null }) => {
    return (
        <>
            {(data) &&
                <>
                    <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:mt-8 mt-4 mb-8">
                        <SectionHeading 
                            title={title} 
                            customClass="text-center" 
                        />
                        <Swiper
                            modules={[Navigation, Autoplay, EffectCoverflow]}
                            speed={300}
                            effect={'coverflow'}
                            grabCursor={true}
                            centeredSlides={true}
                            coverflowEffect={{
                                rotate: 30,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: true,
                            }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            loop={true}
                            breakpoints={{
                                680: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                            }}
                            className="mySwiper">
                            {data?.map((item, i) => (
                                <SwiperSlide key={i}>
                                    <Image 
                                        className={" " + customClass}
                                        priority={true} 
                                        src={process.env.IMG_CDN + item?.imagSrc} 
                                        alt={item?.name} 
                                        width={2000} 
                                        height={2000}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </>
            }
        </>
    )
}
export default LifeAtDi;


